import { Spin, Tooltip } from "antd";
import {
  useProjectDetailsStore,
  useRankingToolStore,
} from "modules/organization/store";
import { LeftOutlined } from "@ant-design/icons";
import ErrorBoundary from "modules/shared/components/ErrorBoundary";
import PageLoader from "modules/shared/components/PageLoader";
import { Fragment, FC, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import QuestionListContainer from "./components/QuestionListContainer";
import RankingToolsEditor from "./components/RankingToolsEditor";
import "./tool-editor.css";
import { useOrganizationRoutes } from "routes/organizationRoute";

const OrgRankingEquationEditorPage: FC = (props) => {
  const { rank_project_id } = useParams<{ rank_project_id: string }>();
  const { projectDetails, isLoadingProjectDetails } = useProjectDetailsStore();
  const {
    getQuestionSnapshot,
    getRankingEquations,
    questionSnapshotList,
    rankingTypeId,
  } = useRankingToolStore();
  const [isLoadingRankingProject, setIsLoadingRankingProject] = useState(false);
  const [rankingProjectNotFound, setRankingProjectNotFound] = useState(false);
  const { organizationBaseRouteUrl } = useOrganizationRoutes();

  useEffect(() => {
    const rankingProjectId = Number(rank_project_id);
    if (!rank_project_id || Number.isNaN(rankingProjectId)) {
      setRankingProjectNotFound(true);
      return;
    }
    if (!projectDetails?.slug) {
      return;
    }
    setIsLoadingRankingProject(true);
    setRankingProjectNotFound(false);
    Promise.all([
      getQuestionSnapshot(projectDetails.slug, rankingProjectId),
      getRankingEquations(projectDetails.slug, rankingProjectId),
    ])
      .catch((error) => {
        console.error(error);
        setRankingProjectNotFound(true);
      })
      .finally(() => {
        setIsLoadingRankingProject(false);
      });
  }, [
    getQuestionSnapshot,
    getRankingEquations,
    rank_project_id,
    projectDetails?.slug,
  ]);

  return (
    <ErrorBoundary>
      <Fragment>
        {isLoadingProjectDetails ? (
          <PageLoader />
        ) : (
          <Spin spinning={isLoadingRankingProject}>
            {projectDetails && (
              <Fragment>
                <div className="pageTopSection">
                  <div className="backLink">
                    <Link
                      to={
                        organizationBaseRouteUrl +
                        `/project/${projectDetails?.slug}/ranking-projects`
                      }
                    >
                      <LeftOutlined role="img" aria-label="" />
                      Back to Ranking Projects
                    </Link>
                  </div>
                  {/* <div className="btnWrap">
                        <Button href='http://www.raosoft.com/samplesize.html' target='_blank'>Guide for Sampling</Button>
                        <Button type="primary" onClick={exportData}>Export to Excel</Button>
                      </div> */}
                </div>
                <div className="pageHeadingWrap">
                  {/* <h2 id="tab-header">Equation Editor</h2> */}
                  <h2
                    className="displayFlex ellipsisTxt"
                    style={{ alignItems: "baseline" }}
                  >
                    <Tooltip
                      placement="right"
                      trigger={["hover"]}
                      title={projectDetails?.title ?? ""}
                      overlayStyle={{ maxWidth: "40%" }}
                    >
                      <p
                        className="ellipsisTxt"
                        style={{ maxWidth: "40%", marginBottom: 0 }}
                      >
                        {projectDetails?.title}
                      </p>
                    </Tooltip>
                    {/* &nbsp;{"|"}&nbsp;
                    <Tooltip
                      placement="right"
                      trigger={["hover"]}
                      title={projectDetails?.title ?? ""}
                      overlayStyle={{ maxWidth: "40%" }}
                    >
                      <p
                        className="ellipsisTxt"
                        style={{ maxWidth: "20%", marginBottom: 0 }}
                      >
                        HIA V1
                      </p>
                    </Tooltip> */}
                    &nbsp;{"|"} Equation Editor{" "}
                  </h2>
                </div>
                <ErrorBoundary>
                  {rankingProjectNotFound ? (
                    <div className="equationEditorWrap">
                      <p>No such ranking project exists.</p>
                    </div>
                  ) : (
                    <div className="equationEditorWrap">
                      <QuestionListContainer
                        projectSlug={projectDetails?.slug}
                        rankingProjectId={Number(rank_project_id)}
                        rankingTypeId={rankingTypeId}
                      />
                      <RankingToolsEditor
                        questions={questionSnapshotList ?? undefined}
                        projectSlug={projectDetails?.slug}
                        rankingProjectId={Number(rank_project_id)}
                        rankingTypeId={rankingTypeId}
                      />
                    </div>
                  )}
                </ErrorBoundary>
              </Fragment>
            )}
          </Spin>
        )}
      </Fragment>
    </ErrorBoundary>
  );
};

export default OrgRankingEquationEditorPage;
